import { InjectionToken } from "@angular/core";

import { Store } from "@se/se.ui.advanced";

import { EcgState } from "../redux/ecgstate";
import { EcgReducer } from "../redux/ecgreducer";

export function createEcgStore() {
    return new Store<EcgState>(new EcgReducer(), new EcgState());
}

export const EcgStore = new InjectionToken('ecg.store');

export const StoreProvider = [
    { provide: EcgStore, useFactory: createEcgStore }
];
